import React from 'react';
import { useTranslation } from 'react-i18next';
import './AboutSection.css';

const TRUST_ITEMS = [{ key: 'analysis', icon: '✦' }, { key: 'style', icon: '↗' }, { key: 'privacy', icon: '◉' }];

export default function AboutSection() {
  const { t } = useTranslation();
  return (
    <section className="home-trust" aria-labelledby="home-trust-title">
      <div className="home-trust-container">
        <header><p>WHY STARTUS</p><h2 id="home-trust-title">{t('home.trust.title')}</h2><span>{t('home.trust.subtitle')}</span></header>
        <div className="home-trust-grid">{TRUST_ITEMS.map(({ key, icon }) => <article key={key}><i aria-hidden="true">{icon}</i><h3>{t('home.trust.' + key + '.title')}</h3><p>{t('home.trust.' + key + '.body')}</p></article>)}</div>
        <small>{t('home.trust.note')}</small>
      </div>
    </section>
  );
}
